import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="testimonial-carousel"
export default class extends Controller {
  static targets = ["slide", "indicator"]
  static values = {
    autoplay: { type: Boolean, default: true },
    interval: { type: Number, default: 5000 }
  }

  connect() {
    this.currentIndex = 0
    this.showSlide(this.currentIndex)
    
    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  disconnect() {
    this.stopAutoplay()
  }

  next() {
    this.stopAutoplay()
    this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length
    this.showSlide(this.currentIndex)
    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  previous() {
    this.stopAutoplay()
    this.currentIndex = (this.currentIndex - 1 + this.slideTargets.length) % this.slideTargets.length
    this.showSlide(this.currentIndex)
    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  goToSlide(event) {
    this.stopAutoplay()
    this.currentIndex = parseInt(event.currentTarget.dataset.index)
    this.showSlide(this.currentIndex)
    if (this.autoplayValue) {
      this.startAutoplay()
    }
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      if (i === index) {
        slide.classList.remove("hidden")
        slide.classList.add("animate-fade-in")
      } else {
        slide.classList.add("hidden")
        slide.classList.remove("animate-fade-in")
      }
    })

    this.indicatorTargets.forEach((indicator, i) => {
      if (i === index) {
        indicator.classList.add("bg-emerald-600")
        indicator.classList.remove("bg-gray-300")
      } else {
        indicator.classList.remove("bg-emerald-600")
        indicator.classList.add("bg-gray-300")
      }
    })
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length
      this.showSlide(this.currentIndex)
    }, this.intervalValue)
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer)
    }
  }
}
